import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { AlertService } from '@src/core/services';
import { UntypedFormGroup } from '@angular/forms';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { Optional } from '@src/types/utils';
import { BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LoyaltyProgramProductInput } from '../../../models';
import { INIT_PRODUCT } from '../../../constants';

@Component({
  template: '',
})
export class AbstractStepComponent extends BaseResizableComponent implements OnChanges {
  @Input() stepForm?: UntypedFormGroup;
  @Output() stepFormChange = new EventEmitter<UntypedFormGroup>();

  @Input() productId?: string;
  @Input() product: LoyaltyProgramProductInput = INIT_PRODUCT;
  @Input() product$ = new BehaviorSubject<Optional<LoyaltyProgramProductInput>>(undefined);

  /** Параметр что текущая ассоциация является РЕКЛАМОДАТЕЛЕМ */
  @Input() isAdvertiser = false;

  private isFirstRender = false;

  protected readonly alertService = inject(AlertService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue && !this.isFirstRender) {
      this.isFirstRender = true;
      this.patchProduct(changes.product?.currentValue);
    }
  }

  get selectSize(): TuiSizeL {
    return this.isDesktop ? 'l' : 'm';
  }

  get optionSize(): TuiSizeS | TuiSizeM {
    return this.isDesktop ? 'm' : 's';
  }

  protected emitForm(form: UntypedFormGroup) {
    this.stepFormChange.emit(form);
    form.valueChanges.pipe(takeUntil(this.destroyed$$)).subscribe(() => this.update());
  }

  protected emitChanges(): Optional<Partial<LoyaltyProgramProductInput>> {
    return undefined;
  }

  protected patchProduct(_product: LoyaltyProgramProductInput) {
    return;
  }

  protected mergeProduct(product: Partial<LoyaltyProgramProductInput>) {
    this.product$.next({ ...this.product, ...product });
  }

  protected update() {
    const data = this.emitChanges();
    if (data) {
      this.mergeProduct(data);
    }
  }
}
